import { render, staticRenderFns } from "./CustomerApplyHandle.vue?vue&type=template&id=211512e8&scoped=true"
import script from "./CustomerApplyHandle.vue?vue&type=script&lang=ts"
export * from "./CustomerApplyHandle.vue?vue&type=script&lang=ts"
import style0 from "./CustomerApplyHandle.vue?vue&type=style&index=0&id=211512e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "211512e8",
  null
  
)

export default component.exports